import script from "./BaseSddsDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSddsDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSddsDropdown.vue?vue&type=style&index=0&id=1d9d1c4b&scoped=true&lang=css"

import exportComponent from "/builds/SalesIT/ijaa/import-tool/ls-import-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d9d1c4b"]])

export default __exports__